export interface DocsNavItem {
  title: string
  description: string
  href: string
  section: string
  keywords: string
}

export const DOCS_NAV_ITEMS: DocsNavItem[] = [
  {
    title: 'What /opendeploy can do',
    description: 'Deploy, configure, debug, operate, and get support from one agent command.',
    href: '/docs/what-opendeploy-can-do',
    section: 'Agent deployment',
    keywords: 'opendeploy deploy env database domain debug ops support setup skills commands volume alarms oncall',
  },
  {
    title: 'Agent platforms, plugins & skills',
    description: 'Install or update OpenDeploy for Claude Code, Codex, Cursor, OpenCode, and OpenClaw.',
    href: '/docs/agent-platforms-plugins-skills',
    section: 'Setup',
    keywords: 'platforms plugins skills claude codex cursor opencode openclaw install update',
  },
]

export function docsSections(items = DOCS_NAV_ITEMS) {
  return items.reduce<Array<{ title: string; items: DocsNavItem[] }>>((sections, item) => {
    const section = sections.find((entry) => entry.title === item.section)
    if (section) {
      section.items.push(item)
    } else {
      sections.push({ title: item.section, items: [item] })
    }
    return sections
  }, [])
}

export function filterDocs(query: string) {
  const q = query.trim().toLowerCase()
  if (!q) return DOCS_NAV_ITEMS

  return DOCS_NAV_ITEMS.filter((item) =>
    [item.title, item.description, item.section, item.keywords]
      .join(' ')
      .toLowerCase()
      .includes(q),
  )
}
